import React, { useState, useEffect } from "react";
import "../App.css";
import Vapi from "@vapi-ai/web";
import ActiveCallDetail from "../components/ActiveCallDetail";
import Button from "../components/base/Button";
import { useAuth } from "../contexts/AuthContext";

function InsuranceApplication() {
  const { logout } = useAuth();
  const vapi = new Vapi("661f7649-d7eb-408c-b559-5dcb41b72531");
  const [isLoading, setIsLoading] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [volumeLevel, setVolumeLevel] = useState(0);
  const [assistantIsSpeaking, setAssistantIsSpeaking] = useState(false);
  const [eventSource, setEventSource] = useState(null);
  const [applicationNo, setApplicationNo] = useState(null);

  useEffect(() => {
    const handleVolumeLevel = (level) => {
      setVolumeLevel(level);
    };
    const handleSpeechStart = () => setAssistantIsSpeaking(true);

    vapi.on("volume-level", handleVolumeLevel);
    vapi.on("speech-start", handleSpeechStart);

    vapi.on("message", (message) => {
      console.log(message);
      if (
        message.toolCalls &&
        message.toolCalls[0] &&
        message.toolCalls[0].function
      ) {
        console.log(
          message.toolCalls[0].function.arguments.registration_number
        );
        console.log(message.toolCalls[0].function.name);
        if (message.toolCalls[0].function.name === "sendUserInformation") {
          setUserInfo(message.toolCalls[0].function.arguments);
        }
      }
    });

    return () => {
      vapi.off("volume-level", handleVolumeLevel);
      vapi.off("speech-start", handleSpeechStart);
    };
  }, []);

  const startFilling = async () => {
    setIsLoading(true);
    vapi.start("c9aa82b9-d3fc-41f1-85fd-223a3751121b");
    console.log(vapi, "Started")
    vapi.send();
    setApplicationNo((Math.random() * 10000000).toFixed(0));
  };

  const stopFilling = () => {
    if (eventSource) {
      eventSource.close();
    }
    console.log("Stopping the assistant");
    vapi.stop();
    window.location.reload();
    setAssistantIsSpeaking(false);
    setIsLoading(false);
  };

  const handlePrint = () => {
    window.print();
  };

  const handleLogout = () => {
    logout();
    stopFilling();
    // No need to navigate here as the protected route will handle that
  };

  if (!isLoading && !userInfo) {
    return (
      <div
        className="App"
        style={{
          display: "flex",
          width: "100vw",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Button
          label="Start Filling Your Auto Insurance Application"
          onClick={startFilling}
        />
        <Button
          label="Logout"
          onClick={handleLogout}
          style={{
            backgroundColor: "#dc2626",
            color: "white",
            marginTop: "20px",
          }}
        />
      </div>
    );
  }

  return (
    <div className="App">
      <header>
        <h1>Auto Insurance Application</h1>
        <div
          className="button-container"
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Button
            label="Logout"
            onClick={handleLogout}
            style={{
              backgroundColor: "#4b5563",
              color: "white",
              padding: "0.5rem 1rem",
              borderRadius: "0.375rem",
            }}
          />
          <Button
            label="Stop"
            onClick={stopFilling}
            style={{
              backgroundColor: "#dc2626",
              color: "white",
              padding: "0.5rem 1rem",
              borderRadius: "0.375rem",
            }}
          />
          <Button
            label="Print"
            onClick={handlePrint}
            style={{
              backgroundColor: "#2563eb",
              color: "white",
              padding: "0.5rem 1rem",
              borderRadius: "0.375rem",
            }}
          />
        </div>
        <p
          style={{
            display: "flex",
            justifyContent: "end",
            marginRight: "1rem",
            fontSize: "1.3rem",
          }}
        >
          Application No:&nbsp;{applicationNo}
        </p>
      </header>
      {!assistantIsSpeaking ? (
        <div className="App loading">
          <div className="loader"></div>
          <p>Connecting you to Regi...</p>
        </div>
      ) : (
        <div>
          <ActiveCallDetail volumeLevel={volumeLevel} />
          <div className="info-container">
            <section>
              <h2>Personal Information</h2>
              {userInfo?.name && (
                <p>
                  <strong>Name:</strong> {userInfo?.name}
                </p>
              )}
              {userInfo?.mobileNumber && (
                <p>
                  <strong>Mobile:</strong> {userInfo?.mobileNumber}
                </p>
              )}
              {userInfo?.emailAddress && (
                <p>
                  <strong>Email:</strong> {userInfo?.emailAddress}
                </p>
              )}
              {userInfo?.dateOfBirth && (
                <p>
                  <strong>DOB:</strong> {userInfo?.dateOfBirth}
                </p>
              )}
            </section>

            <section>
              <h2>Vehicle Information</h2>
              {userInfo?.vehicleType && (
                <p>
                  <strong>Type:</strong> {userInfo?.vehicleType}
                </p>
              )}
              {userInfo?.vehicleRegistrationNumber && (
                <p>
                  <strong>Reg. Number:</strong>{" "}
                  {userInfo?.vehicleRegistrationNumber}
                </p>
              )}
              {userInfo?.carDetails && (
                <div>
                  {userInfo?.carDetails.make && (
                    <p>
                      <strong>Make:</strong> {userInfo?.carDetails.make}
                    </p>
                  )}
                  {userInfo?.carDetails.model && (
                    <p>
                      <strong>Model:</strong> {userInfo?.carDetails.model}
                    </p>
                  )}
                  {userInfo?.carDetails.fuelType && (
                    <p>
                      <strong>Fuel Type:</strong>{" "}
                      {userInfo?.carDetails.fuelType}
                    </p>
                  )}
                  {userInfo?.carDetails.registrationDate && (
                    <p>
                      <strong>Reg. Date:</strong>{" "}
                      {userInfo?.carDetails.registrationDate}
                    </p>
                  )}
                </div>
              )}
            </section>

            <section>
              <h2>Insurance Details</h2>
              {userInfo?.claimHistory != null && (
                <p>
                  <strong>Claim History:</strong>{" "}
                  {userInfo?.claimHistory ? "Claimed" : "Not Claimed"}
                </p>
              )}
              {userInfo?.noClaimBonus ? (
                <p>
                  <strong>No Claim Bonus:</strong> {userInfo?.noClaimBonus} %
                </p>
              ) : userInfo?.claimHistory === false ? (
                <p>
                  <strong>No Claim Bonus Options:</strong> 0% &nbsp; 20% &nbsp;
                  25% &nbsp; 35% &nbsp; 45% &nbsp; 50% &nbsp;
                </p>
              ) : null}
            </section>

            <section className="two-column">
              <div>
                <h2>Add-Ons</h2>
                {userInfo?.addOns && (
                  <ul>
                    {userInfo.addOns.nilDepreciation != null && (
                      <li>
                        <strong>Nil Depreciation:</strong>{" "}
                        {userInfo.addOns.nilDepreciation ? "Yes" : "No"}
                      </li>
                    )}
                    {userInfo.addOns.engineProtector != null && (
                      <li>
                        <strong>Engine Protector:</strong>{" "}
                        {userInfo.addOns.engineProtector ? "Yes" : "No"}
                      </li>
                    )}
                    {userInfo.addOns.securePlus != null && (
                      <li>
                        <strong>Secure Plus:</strong>{" "}
                        {userInfo.addOns.securePlus ? "Yes" : "No"}
                      </li>
                    )}
                  </ul>
                )}
              </div>

            
            </section>
            <section className="two-column">
              <div>
                <h2>IDV</h2>
                {userInfo?.idv ? (
                  <p>
                    <strong>IDV:</strong> ₹{userInfo?.idv}
                  </p>
                ) : userInfo?.discounts?.automobileAssociation != null ? (
                  <p>
                    <ol>
                      <li>₹27,72,200</li>
                      <li>₹33,95,700</li>
                      <li>₹43,31,250</li>
                    </ol>
                  </p>
                ) : null}
              </div>
              <div>
                <h2>Annual Premium</h2>
                {userInfo?.idv && (
                  <p>
                    <strong>Annual Premium:</strong> ₹62,935
                  </p>
                )}
              </div>
            </section>

            <section>
              <h2>Application Status</h2>
              {userInfo?.kycDocuments != undefined && (
                <p>
                  <strong>KYC Documents:</strong>{" "}
                  {userInfo?.kycDocuments ? "Uploaded" : "Pending"}
                </p>
              )}
              {userInfo?.isSubmitting != undefined && (
                <p>
                  <strong>Submission:</strong>{" "}
                  {userInfo?.isSubmitting ? "Submitted" : "Not Started"}
                </p>
              )}
            </section>
          </div>
        </div>
      )}
    </div>
  );
}

export default InsuranceApplication;

//disscount section which is removed

//  <div>
//                 <h2>Discounts</h2>
//                 {userInfo?.discounts && (
//                   <ul>
//                     {userInfo.discounts.antiTheftDevice != null && (
//                       <li>
//                         <strong>Anti-Theft Device:</strong>{" "}
//                         {userInfo.discounts.antiTheftDevice ? "Yes" : "No"}
//                       </li>
//                     )}
//                     {userInfo.discounts.automobileAssociation != null && (
//                       <li>
//                         <strong>Automobile Association:</strong>{" "}
//                         {userInfo.discounts.automobileAssociation
//                           ? "Yes"
//                           : "No"}
//                       </li>
//                     )}
//                   </ul>
//                 )}
//               </div>